import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck, Check } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/common/Reveal";
import { COMPLIANCE, IMAGES } from "@/data/site";
import { CATEGORIES } from "@/data/products";

const OFFERS = [
  { key: "supply", title: "Supply & installation", image: CATEGORIES[0].cover, to: "/solutions", cta: "Browse 39 products", points: ["Extinguishers, fire balls, blankets, signage, evacuation gear and firefighter PPE, supplied and wall-mounted", "Fire detection, alarm panels, voice evacuation and emergency lighting, wired by our electrical team", "One quote for every site, with specifications referenced to the latest IS and NBCS 2026"] },
  { key: "amc", title: "Annual maintenance (AMC)", image: IMAGES.inspection, to: "/amc", cta: "Explore AMC plans", points: ["Scheduled inspections with service tags and records for every asset", "Breakdown response and status updates through the vendor portal", "Audit-ready documentation for your compliance team"] },
];

export const OfferBlock = () => (
  <section className="bg-white py-24" data-testid="home-offers">
    <div className="container-x">
      <SectionHeading eyebrow="What we do" title="Two things, done properly: supply and AMC." />
      <div className="mt-12 grid gap-6 lg:grid-cols-2">
        {OFFERS.map((o, i) => (
          <Reveal key={o.key} delay={i * 0.08}>
            <div className="card-base flex h-full flex-col overflow-hidden" data-testid={`home-offer-${o.key}`}>
              <img src={o.image} alt={o.title} loading="lazy" className="h-56 w-full object-cover" />
              <div className="flex flex-1 flex-col p-8">
                <h3 className="text-2xl font-semibold text-slate-900">{o.title}</h3>
                <ul className="mt-5 flex-1 space-y-3">
                  {o.points.map((pt) => <li key={pt} className="flex gap-2.5 text-sm leading-relaxed text-slate-600"><Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" /> {pt}</li>)}
                </ul>
                <Link to={o.to} className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-[#C20500] transition-[gap] hover:gap-3" data-testid={`home-offer-${o.key}-link`}>{o.cta} <ArrowRight className="h-4 w-4" /></Link>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const ComplianceBand = () => (
  <section className="bg-[#F4F6F2] py-20" data-testid="home-compliance">
    <div className="container-x grid gap-10 lg:grid-cols-3 lg:items-center">
      <SectionHeading eyebrow="Standards" title="Standards-led by default." text="Every recommendation references the code it satisfies. Certificates are shared with verified buyers on request." />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:col-span-2">
        {COMPLIANCE.map((c) => (
          <div key={c.code} className="card-base flex items-center gap-3 p-4">
            <BadgeCheck className="h-5 w-5 shrink-0 text-emerald-600" />
            <div>
              <p className="mono text-sm font-semibold text-slate-900">{c.code}</p>
              <p className="text-xs text-slate-500">{c.title}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
